import { render, staticRenderFns } from "./CalculateSalaryProcessView.vue?vue&type=template&id=af8ce28a&"
import script from "./CalculateSalaryProcessView.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports